module.exports = __webpack_public_path__ + "img/auto-Shields.285bea21.png";